import React from 'react';
import { motion } from 'framer-motion';

const SoftvativeFooter = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-12 text-center py-6 border-t border-white/10"
    >
      <div className="text-gray-400">
        Developed by{' '}
        <motion.a
          href="https://softvative.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 font-semibold transition-colors duration-300"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Softvative.com
        </motion.a>
      </div>
      
      <div className="mt-2 text-xs text-gray-500">
        © 2024 Softvative. All rights reserved.
      </div>
    </motion.footer>
  );
};

export default SoftvativeFooter;